'use client';

import { useSyncExternalStore } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';

const subscribeToNothing = () => () => {};

export default function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const mounted = useSyncExternalStore(subscribeToNothing, () => true, () => false);

  const isDark = resolvedTheme !== 'light';
  const nextTheme = isDark ? 'light' : 'dark';

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="h-9 w-9 border-border/50 bg-primary/10 text-foreground hover:bg-primary/15 focus-visible:ring-2 focus-visible:ring-primary"
      onClick={() => setTheme(nextTheme)}
      aria-label="Toggle theme"
      title={mounted ? `Switch to ${nextTheme} mode` : undefined}
    >
      {mounted && (isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />)}
    </Button>
  );
}
